// ---------------------------------------------------------------------------
// types
// ---------------------------------------------------------------------------

export interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  items: FAQItem[];
}

// ---------------------------------------------------------------------------
// main
// ---------------------------------------------------------------------------

export default function FAQSection({ items }: FAQSectionProps) {
  const midpoint = Math.ceil(items.length / 2);
  const leftColumn = items.slice(0, midpoint);
  const rightColumn = items.slice(midpoint);

  return (
    <section className="w-full bg-clay-100 px-5 py-16 md:py-28">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-16 md:gap-20">
        {/* header */}
        <h2 className="font-clash text-4xl lg:text-[52px] font-medium leading-[1.1] tracking-[-1px] text-ash-900 text-center">
          Frequently asked questions
        </h2>

        {/* two-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-[1000px]">
          <div className="flex flex-col gap-6">
            {leftColumn.map((item) => (
              <FAQCard key={item.question} item={item} />
            ))}
          </div>
          <div className="flex flex-col gap-6">
            {rightColumn.map((item) => (
              <FAQCard key={item.question} item={item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ---------------------------------------------------------------------------
// card
// ---------------------------------------------------------------------------

function FAQCard({ item }: { item: FAQItem }) {
  return (
    <div className="flex flex-col gap-3 rounded-3xl border border-ash-300 bg-white p-6">
      <h3 className="text-lg font-bold leading-normal text-ash-900">{item.question}</h3>
      <p className="text-base leading-normal text-ash-900">{item.answer}</p>
    </div>
  );
}
